'use client';
import Typography from '@/components/shared/typography/typography.component';
import React, { FC, useContext, useMemo, useState } from 'react';
import { useTranslation, useWindowDimensions } from '@/hook';
import {
  ArrowDownBlueWithTail,
  ArrowDownPrimaryWithTail,
  BlueInfo,
  GreenInfo,
  XBlue,
  XPrimary,
} from '../../../../../../public/Images';
import { CarProfileContext } from '@/contexts/carProfile.context';
import classes from './style.module.scss';
import Image from 'next/image';
import colors from '@/theme/colors.module.scss';

interface ICarSoldInfoBoxMobile {
  type: 'SOLD' | 'PURCHASE_IN_PROGRESS';
}

const CarSoldInfoBoxMobile: FC<ICarSoldInfoBoxMobile> = ({ type }) => {
  const { t, i18n } = useTranslation();
  const { IS_DESKTOP } = useWindowDimensions();
  const { scrollToPosition } = useContext(CarProfileContext);
  const [isOpen, setisOpen] = useState<boolean>(true);

  const scrollOptions: ScrollToOptions = {
    left: 0,
    top: scrollToPosition - 50,
    behavior: 'smooth',
  };
  const title = useMemo<string>(
    () => (type === 'SOLD' ? t('soldPage.title') : t('purchaseInProgress.title')),
    [type],
  );
  const description = useMemo<string>(
    () => (type === 'SOLD' ? t('soldPage.descriptionLong') : t('purchaseInProgress.description')),
    [type],
  );
  const cta = useMemo<string>(
    () => (type === 'SOLD' ? t('soldPage.CTA') : t('soldPage.CTA')),
    [type],
  );
  const closeInfoBox = () => {
    setisOpen(false);
  };
  const titleColor = useMemo<string>(
    () => (type === 'SOLD' ? colors.primary700 : colors.secondary500),
    [type],
  );
  const subtitleColor = useMemo<string>(
    () => (type === 'SOLD' ? colors.success600 : colors.secondary400),
    [type],
  );
  return isOpen ? (
    <div
      className={`${classes.container} ${
        type === 'SOLD' ? classes.containerSold : classes.containerPurchaseInProgress
      }`}
    >
      <div className={classes.header}>
        <Image
          src={type === 'SOLD' ? GreenInfo : BlueInfo}
          alt="GreenInfo"
          width={20}
          height={20}
        />
        {!IS_DESKTOP && (
          <Image
            src={type === 'SOLD' ? XPrimary : XBlue}
            alt="XPrimary"
            width={15}
            height={15}
            onClick={closeInfoBox}
          />
        )}
      </div>
      <div className={classes.containerInner}>
        <Typography variant="body2Medium" style={{ color: titleColor }}>
          {title}
        </Typography>
        <Typography variant="body2" style={{ color: subtitleColor }}>
          {description}
        </Typography>
        <div onClick={() => window.scrollTo(scrollOptions)} className={classes.bottom}>
          <Typography variant="body2Medium" style={{ color: titleColor }}>
            {cta}
          </Typography>
          <Image
            src={type === 'SOLD' ? ArrowDownPrimaryWithTail : ArrowDownBlueWithTail}
            alt="arrow"
          />
        </div>
      </div>
      {IS_DESKTOP && (
        <Image
          src={type === 'SOLD' ? XPrimary : XBlue}
          alt="XPrimary"
          width={15}
          height={15}
          onClick={closeInfoBox}
        />
      )}
    </div>
  ) : (
    <></>
  );
};

export default CarSoldInfoBoxMobile;
